import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CouponSearchDto } from '../../shared/dto/coupon-search.dto';
import { SelectItem } from 'primeng/api';
import { TranslationService } from 'src/app/shared';

@Component({
  selector: 'wl-coupon-search-params',
  templateUrl: './coupon-search-params.component.html',
  styleUrls: ['./coupon-search-params.component.less'],
    standalone: false
})
export class CouponSearchParamsComponent implements OnInit {
  @Input()
  get searchParams() {
    return this._searchParams;
  }
  set searchParams(value: CouponSearchDto) {
    this._searchParams = value;
    this.searchParamsChange.emit(this._searchParams);
  }
  @Output() searchParamsChange: EventEmitter<CouponSearchDto> = new EventEmitter();

  statusItems: SelectItem[] = [];
  private _searchParams: CouponSearchDto;
  constructor(private _translationService: TranslationService) {
    this.searchParams = new CouponSearchDto();
  }

  async ngOnInit(): Promise<void> {
    this.statusItems = [
      { label: await this._translationService.get('coupons.search.all'), value: null },
      { label: await this._translationService.getTitlecase('coupons.search.approved'), value: true },
      { label: await this._translationService.getTitlecase('coupons.search.unapproved'), value: false },
    ];
  }
}
